import * as React from 'react';
import { Link } from 'react-router-dom';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import * as ReqType from '../../../types/ServerRequests';
import { UserService } from '../../../services/UserService';
import { MediaService } from '../../../services/MediaService';

interface Props {
    user: ReqType.UserView;
    changeCallback: (user: ReqType.UserView) => Promise<void>;
}

interface State {
    photoProfile: string;
}

/**
 * Ce composant permet d'afficher une ligne de la liste des utilisateurs
 */
export class UserLine extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            photoProfile: require('../../ProfilePage/internalComponents/photoProfile.PNG')
        };
        this.getPhotoProfile();
    }

    public getPhotoProfile(): void {
        const userId = this.props.user.id;
        if (userId !== undefined) {
            UserService.getInstance().getUser(userId).then(
                (response: ReqType.UserView) => {
                    // alert(response.userProfile!.photo_profil);
                    if (response.userProfile === null || response.userProfile.photo_profil === null) {
                        this.setState({ photoProfile: require(
                            '../../ProfilePage/internalComponents/photoProfile.PNG') });
                    } else {
                        this.setState({
                            photoProfile: MediaService.getInstance().getBaseURL() +
                            response.userProfile!.photo_profil
                        });
                    }
                }).catch(
                (error) => {
                    // alert(error);
                }
            );
        }
    }

    render() {
        return (
            <tr key={this.props.user.id}>
                <td scope="col">
                    <img
                        src={this.state.photoProfile}
                        className="img-thumbnail mx-auto d-block rounded-circle border-danger"
                        alt="Photo de profil"
                        height="80px"
                        width="80px"
                    />
                </td>
                <td scope="row">
                    <strong>
                        {this.props.user.userProfile === null ? '' : this.props.user.userProfile.nom}
                    </strong>
                </td>
                <td scope="row">{this.props.user.userProfile === null ? '' : this.props.user.userProfile.prenom}</td>
                <td scope="row">{this.props.user.username}</td>
                <td scope="row">{this.props.user.email}</td>
                <td>
                    <Link to={'/userlist/' + this.props.user.id}>
                        <button className="btn btn-default">
                            <i className="fas fa-eye" />
                        </button>
                    </Link>
                </td>
                {this.props.user.status === 2 ?
                    (
                        <td>
                            <LoaderButton
                                className="btn btn-danger"
                                onClick={this.changeUserServer}
                                confirmation={true}
                                modalTitle="Désactivation"
                                modalBody={
                                    'Voulez-vous vraiment desactiver l\'utilisateur : ' + this.props.user.username
                                }
                            >
                                Desactiver
                            </LoaderButton>
                        </td>
                    ) :
                    (
                        <td>
                            <LoaderButton
                                className="btn btn-success"
                                onClick={this.changeUserServer}
                                confirmation={true}
                                modalTitle="Activation"
                                modalBody={
                                    'Voulez-vous vraiment réactiver l\'utilisateur : ' + this.props.user.username
                                }
                            >
                                Activer
                            </LoaderButton>
                        </td>
                    )
                }
            </tr>
        );
    }

    private changeUserServer = () => {
        var newUser = UserService.getInstance().duplicateUserView(this.props.user);
        newUser.status = (this.props.user.status === 1 ? 2 : 1);
        return this.props.changeCallback(newUser);
    }
}


// WEBPACK FOOTER //
// ./src/components/UserListPage/internalComponents/UserLine.tsx